import request from '@/utils/request'

export const getUnits = (params) => {
  return request({
    url: '/api/units',
    method: 'get',
    params
  })
}

export const getUnit = (id) => {
  return request({
    url: `/api/units/${id}`,
    method: 'get'
  })
}

export const createUnit = (data) => {
  return request({
    url: '/api/units',
    method: 'post',
    data
  })
}

export const updateUnit = (id, data) => {
  return request({
    url: `/api/units/${id}`,
    method: 'put',
    data
  })
}

export const deleteUnit = (id) => {
  return request({
    url: `/api/units/${id}`,
    method: 'delete'
  })
}